import { render, staticRenderFns } from "./Look.vue?vue&type=template&id=bddc4c80&"
import script from "./Look.vue?vue&type=script&lang=js&"
export * from "./Look.vue?vue&type=script&lang=js&"
import style0 from "./Look.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports